module.exports = __webpack_public_path__ + "static/media/fb_my.91fd43c5.png";